// frontend/src/components/chat/ChatHeader.js
// Header del chat - Info de conversacion

import React, { useState } from 'react';
import './ChatHeader.css';

const ChatHeader = ({ conversation, onBack, onClose, onShowInfo }) => {
    const [showMenu, setShowMenu] = useState(false);

    // Obtener estado online
    const getStatus = () => {
        if (conversation.type === 'group') {
            return `${conversation.member_count || 0} miembros`;
        }
        return conversation.is_online ? 'En linea' : 'Desconectado';
    };

    return (
        <div className="urbanq-chat-header">
            {/* Boton volver (movil) */}
            {onBack && (
                <button className="urbanq-header-back" onClick={onBack}>
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                    </svg>
                </button>
            )}

            {/* Avatar */}
            <div className="urbanq-header-avatar" onClick={() => onShowInfo?.()}>
                {conversation.display_avatar ? (
                    <img src={conversation.display_avatar} alt="" />
                ) : (
                    <span className={`urbanq-header-avatar-initial ${conversation.type === 'group' ? 'group' : ''}`}>
                        {conversation.type === 'group' ? '👥' : (conversation.display_name?.charAt(0).toUpperCase() || '?')}
                    </span>
                )}
                {conversation.type === 'individual' && conversation.is_online && (
                    <span className="urbanq-header-online"></span>
                )}
            </div>

            {/* Info */}
            <div className="urbanq-header-info" onClick={() => onShowInfo?.()}>
                <h4 className="urbanq-header-name">
                    {conversation.display_name || conversation.name || 'Chat'}
                </h4>
                <span className={`urbanq-header-status ${conversation.is_online ? 'online' : ''}`}>
                    {getStatus()}
                </span>
            </div>

            {/* Acciones */}
            <div className="urbanq-header-actions">
                <button
                    className="urbanq-header-btn"
                    onClick={() => onShowInfo?.()}
                    title="Informacion"
                >
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                    </svg>
                </button>

                <div className="urbanq-header-menu-container">
                    <button
                        className="urbanq-header-btn"
                        onClick={() => setShowMenu(!showMenu)}
                        title="Mas opciones"
                    >
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
                        </svg>
                    </button>

                    {showMenu && (
                        <div className="urbanq-header-menu">
                            <button onClick={() => { setShowMenu(false); onShowInfo?.(); }}>
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                                </svg>
                                Ver informacion
                            </button>
                            <button onClick={() => setShowMenu(false)}>
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"/>
                                </svg>
                                Silenciar
                            </button>
                        </div>
                    )}
                </div>

                {onClose && (
                    <button
                        className="urbanq-header-btn"
                        onClick={onClose}
                        title="Cerrar"
                    >
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </button>
                )}
            </div>
        </div>
    );
};

export default ChatHeader;
